import React, { Fragment } from "react";
import Header from "../../../components/Header/Header";
import PageTitle from "../../../components/pagetitle/PageTitle";
import Scrollbar from "../../../components/scrollbar/scrollbar";
import Footer from "../../../components/footer/Footer";
import img13 from "../../../images/service//webapp/cms.png";
import ServiceHero from "../components/ServiceHero";
import ServiceJourney from "../components/ServiceJourney";
import ServiceCapabilities from "../components/ServiceCapabilities";
import ServiceResults from "../components/ServiceResults";
import ServiceOutcomes from "../components/ServiceOutcomes";
import ServiceWhyChooseUs from "../components/ServiceWhyChooseUs";
import FaqSection from "../../../components/PageSection/FAQsection";

const CMSDevelopment = () => {
  const heroData = {
    title: "Custom Content Management System Development",
    description: "Empower your team with intuitive content management systems that make creating, managing, and publishing content effortless. We build CMS solutions that streamline your workflows and enhance your digital presence.",
    image: img13,
    imageAlt: "CMS Development",
    features: [
      "User-friendly interfaces",
      "Custom content types",
      "SEO optimization tools",
      "Media management",
      "Role-based access",
      "Publishing workflows",
    ],
    pillars: [
      "Intuitive interface that empowers content creators",
      "Flexible architecture that adapts to your content needs",
      "Powerful features that streamline content workflows",
    ],
  };

  const journeySteps = [
    {
      title: "Requirements Analysis",
      description: "We identify your content management needs, user roles, and workflow requirements to design the perfect CMS solution for your organization.",
      details: ["Content audit", "User roles", "Workflow mapping", "Content types", "Integration needs", "Success criteria"],
    },
    {
      title: "Custom CMS Design",
      description: "Our team creates intuitive content management interfaces and custom modules tailored to your specific content types and publishing workflows.",
      details: ["Interface design", "Custom fields", "Content templates", "Media library", "Publishing flow", "Preview features"],
    },
    {
      title: "Development & Migration",
      description: "We build your CMS platform and handle seamless content migration from existing systems, ensuring zero downtime and data integrity.",
      details: ["CMS development", "Plugin creation", "Data migration", "API integration", "Performance optimization", "Security hardening"],
    },
    {
      title: "Training & Support",
      description: "Comprehensive user training and ongoing support ensure your team can effectively manage and publish content with confidence.",
      details: ["User training", "Documentation", "Admin guides", "Video tutorials", "Technical support", "Ongoing maintenance"],
    },
  ];

  const capabilities = [
    {
      title: "WordPress Solutions",
      content:
        "Custom WordPress development with advanced plugins, themes, and enterprise-grade security for flexible content management.",
    },
    {
      title: "Headless CMS",
      content:
        "Modern headless CMS platforms like Strapi, Contentful, or Sanity that decouple content from presentation for omnichannel delivery.",
    },
    {
      title: "Custom CMS",
      content:
        "Bespoke content management systems built from scratch to match your exact requirements and business processes.",
    },
    {
      title: "eCommerce CMS",
      content:
        "Specialized CMS solutions for product catalogs, pricing management, and inventory control integrated with your ecommerce platform.",
    },
  ];

  const resultsData = {
    metrics: [
      { value: "-75%", label: "Content publishing time" },
      { value: "3x", label: "Content team productivity" },
      { value: "+45%", label: "Organic search traffic" },
    ],
    description: "We deliver CMS solutions that dramatically improve content management efficiency, reduce publishing time, and enhance team productivity.",
  };

  const outcomesData = {
    description: "We create content management systems that combine powerful functionality with ease of use, enabling your team to create and publish compelling content efficiently.",
    outcomes: [
      "Intuitive content editor with WYSIWYG capabilities",
      "Custom content types and taxonomies",
      "Multi-user roles and permissions",
      "Media library with asset management",
      "SEO metadata and preview tools",
      "Publishing workflows and scheduling",
    ],
  };

  const whyChooseUs = [
    {
      title: "User-Friendly Interface",
      content:
        "We design intuitive admin panels that make content management effortless, even for non-technical users.",
    },
    {
      title: "SEO-Optimized",
      content:
        "Built-in SEO tools and optimization features ensure your content ranks well in search engines and drives organic traffic.",
    },
    {
      title: "Flexible & Scalable",
      content:
        "Our CMS solutions grow with your business, supporting increased content volume and new content types as needed.",
    },
    {
      title: "Security Hardened",
      content:
        "Enterprise-level security with regular updates, access controls, and protection against common vulnerabilities.",
    },
  ];

  const faqs = [
    {
      q: "Which CMS platform is best for my business?",
      a: "It depends on your needs. WordPress is great for blogs and marketing sites, headless CMS like Contentful for omnichannel, and custom CMS for unique workflows. We'll recommend the best fit during our consultation.",
    },
    {
      q: "Can you migrate content from our existing CMS?",
      a: "Yes! We specialize in seamless CMS migrations, transferring all your content, media, users, and settings while maintaining SEO rankings and ensuring zero downtime during the transition.",
    },
    {
      q: "Will non-technical team members be able to use the CMS?",
      a: "Absolutely. We design user-friendly interfaces with WYSIWYG editors and provide comprehensive training to ensure your entire team can confidently create and publish content.",
    },
    {
      q: "How do you ensure CMS security?",
      a: "We implement security best practices including regular updates, role-based access controls, secure authentication, automated backups, and protection against common vulnerabilities like SQL injection and XSS attacks.",
    },
  ];

  return (
    <Fragment>
      <div className="br-app">
        <div id="page" className="page">
          <Header />
          <PageTitle
            pageTitle={"CMS Development"}
            pagesub={"Web & App Development"}
          />
          <main className="page_content service-detials">
            <section className="pt-130 pb-130 gray-bg">
              <div className="container">
                <ServiceHero {...heroData} />
                <ServiceJourney title="Our CMS Creation Journey" steps={journeySteps} />
                <ServiceCapabilities capabilities={capabilities} />
                <ServiceResults {...resultsData} />
                <ServiceOutcomes {...outcomesData} />
                <ServiceWhyChooseUs items={whyChooseUs} />
                <FaqSection faqs={faqs} />
              </div>
            </section>
          </main>
          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default CMSDevelopment;
